import React, { useEffect, useState } from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from 'react-router-dom';

import { obtenirDeploiements } from './deploiementApi';

const lireDate = (rapport) => {
  const rapportInterne = (rapport && rapport.rapport) || {};
  const valeur = (rapport && (rapport.dateRapport || rapport.createdAt || rapport.date)) || rapportInterne.date;
  if (!valeur) return '-';
  const date = new Date(valeur);
  if (Number.isNaN(date.getTime())) return valeur;
  return date.toLocaleString();
};

const lireVersion = (rapport) => {
  const referenceVersion = (rapport && rapport.referenceVersion) || {};
  if (referenceVersion.version) return referenceVersion.version;
  if (rapport && rapport.version) return rapport.version;
  if (referenceVersion.commit) return referenceVersion.commit;
  return '-';
};

function DeploiementReportsList({ rafraichirDeclencheur }) {
  const [rapports, setRapports] = useState([]);
  const [chargement, setChargement] = useState(true);
  const [erreur, setErreur] = useState('');

  useEffect(() => {
    let actif = true;
    setChargement(true);
    setErreur('');
    obtenirDeploiements()
      .then((data) => {
        if (!actif) return;
        setRapports(Array.isArray(data) ? data : []);
      })
      .catch((err) => {
        if (!actif) return;
        setErreur(err.message || "Impossible de charger l'historique.");
      })
      .finally(() => {
        if (actif) setChargement(false);
      });
    return () => { actif = false; };
  }, [rafraichirDeclencheur]);

  return (
    <Paper style={{ padding: 16 }}>
      <Typography variant="h6">Historique des rapports</Typography>
      {chargement && <div style={{ marginTop: 16 }}><CircularProgress size={24} /></div>}
      {erreur && <Typography color="error" style={{ marginTop: 16 }}>{erreur}</Typography>}

      {!chargement && !erreur && (
        <div style={{ marginTop: 12, overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Environnement</TableCell>
                <TableCell>Operateur</TableCell>
                <TableCell>Decision</TableCell>
                <TableCell>Version/commit</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rapports.map((rapport, index) => (
                <TableRow key={rapport._id || rapport.id || index}>
                  <TableCell>{lireDate(rapport)}</TableCell>
                  <TableCell>{rapport.environnementCible || '-'}</TableCell>
                  <TableCell>{rapport.operateur || '-'}</TableCell>
                  <TableCell>{rapport.decisionFinale || '-'}</TableCell>
                  <TableCell>{lireVersion(rapport)}</TableCell>
                  <TableCell align="right">
                    <Button
                      component={Link}
                      to={'/Ingenierie/Deploiements/' + encodeURIComponent(rapport._id || rapport.id)}
                      color="primary"
                      variant="outlined"
                      size="small"
                      disabled={!rapport._id && !rapport.id}
                    >
                      Consulter
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {rapports.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6}>Aucun rapport enregistre.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      )}
    </Paper>
  );
}

export default DeploiementReportsList;



// WEBPACK FOOTER //
// src/components/deploiements/DeploiementReportsList.js